import { Action, Module, Mutation, VuexModule } from "vuex-module-decorators";
import { RootState } from "@/store";
import { queryRequest } from "@/utils/request";
import { getSystemValue } from "@/graphql/app.gql";
import {
  getGrowthAccount,
  getGrowthValueCenter
} from "@/graphql/star-level.gql";
import { queryDataDictionaryListLang } from "@/graphql/dictionary.gql";

export interface StartLevelCenterState {}

@Module({ name: "StartLevelCenterModule", namespaced: true })
export default class StartLevelCenterModule
  extends VuexModule<StartLevelCenterState, RootState>
  implements StartLevelCenterState {
  public levelConfig: any = []; // 星级配置
  public userLevel: any = {};
  public rewardConfig: string = ""; //奖励上限配置

  @Mutation
  setLevelConfigMutation(data = []) {
    this.levelConfig = data || [];
  }
  @Mutation
  setRewardConfigMutation(data = "") {
    this.rewardConfig = data || "";
  }
  @Mutation
  setUserLevelMutation(data = {}) {
    this.userLevel = data || {};
  }

  //  查询星级配置
  @Action
  async queryLevelConfigAction() {
    let { value } = await queryRequest({
      query: getSystemValue,
      variables: {
        input: { valueCode: "TBR_GROWTH_VALUE" } // 星级中心配置
      }
    });
    try {
      value = JSON.parse(value);
      this.context.commit("setLevelConfigMutation", value);
    } catch (e) {
      console.log(e);
    }
  }

  //  查询奖励上限
  @Action
  async queryRewardConfigAction() {
    let { value } = await queryRequest({
      query: getSystemValue,
      variables: {
        input: { valueCode: "TBR_GROWTH_UP" } // 奖励上线配置
      }
    });
    try {
      this.context.commit("setRewardConfigMutation", value);
    } catch (e) {
      console.log(e);
    }
  }

  // 查询用户星级成长值
  @Action
  async getGrowthAccountAction() {
    const data = await queryRequest({
      query: getGrowthValueCenter
    });
    this.context.commit("setUserLevelMutation", {
      ...data,
      amount: Number(data.amount)
    });
  }
}
